<template>
    <div class="context common_table_view">
        <div class="header">
            <div class="search search_box">
                <el-form :model="searchForm" inline size="small">
                    <el-form-item label="标题">
                        <el-input class="width_200"
                                  @change="getTableData"
                                  v-model="searchForm.input"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="getTableData" type="primary">搜索</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="btn_box">
                <el-button @click="add_dialog" size="small">新增提醒</el-button>
            </div>
        </div>
        <div class="table">
            <el-table :data="tableData"
                      stripe
                      width="100%"
                      height="100%">
                <el-table-column v-for="(item, index) in columnData"
                                 :prop="item.prop"
                                 :label="item.label"
                                 :width="item.width"
                                 :formatter="item.formatter"
                                 :fixed="item.fixed"
                                 show-overflow-tooltip
                                 :key="index"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="table_btn"
                              @click="editRow(scope.row)">
                            <i class="el-icon-edit"></i>
                            编辑
                        </span>
                        <span class="table_del_btn"
                              @click="delRow(scope.row)">
                            <i class="el-icon-delete"></i>
                            删除
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>

    </div>
</template>

<script>
    import {clone} from "../../global/utils";
    import {mapState, mapMutations} from "vuex"

    export default {
        name: "tableView",
        data() {
            return {
                searchForm: {
                    input: '',
                },
                tableData: [],
                columnData: [
                    {label: '标题', prop: 'title'},
                    {label: '摘要', prop: 'abstract'},
                    {label: '内容', prop: 'content'},
                    {label: '备注', prop: 'remark'},
                ],
            }
        },
        mounted() {
            this.getTableData()
        },
        methods: {
            ...mapMutations("questionData", {
                setWarningsAdd: 'setWarningsAdd'
            }),
            getTableData() {
                let params = {
                    title: this.searchForm.input,
                    wtype: 'G_REMIND'
                };
                this.httpGet('/wording/list', params).then(res => {
                    this.tableData = res.data;
                });
            },

            add_dialog() {
                let params = {
                    title: '新增提醒',
                    form: {
                        title: '',
                        abstract: '',
                        content: '',
                        remark: '',
                    }
                };
                this.setWarningsAdd(params);
                this.$emit("changeTopTab", 'addView')
            },
            editRow(row) {
                let params = {
                    title: '修改提醒',
                    form: clone(row)
                };
                this.setWarningsAdd(params);
                this.$emit("changeTopTab", 'addView')
            },
            delRow(row) {
                this.httpDel(`/wording/${row.wording_id}`).then(res => {
                    if (res.code === 0) {
                        this.$message.success('已成功删除！');
                        this.getTableData();
                    }
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
    }
</style>